import React from 'react';
import {Row, Col, Form} from 'react-bootstrap';
import createUUID from '../../util/createUUID';
import useCheckFilterFieldsValidity from '../../util/useCheckFilterFieldsValidity';
import checkOtherFiltersValid from '../../util/checkOtherFiltersValid';
import {useTranslation} from 'react-i18next';
import Filter from './Filter';

const FilterRangeField = (props) => {
    const {t} = useTranslation();
    const checkFieldsValidity = useCheckFilterFieldsValidity();

    return <Filter
        key={`filter-${props.filter.name}`}
        filters={props.filters}
        setFilters={props.setFilters}
        loading={props.loading}
        filter={props.filter}
        filtersInitial={props.filtersInitial}
    >
        <div
            style={
                {
                    position: 'relative',
                    // overflow: 'hidden'
                }
            }
        >
            <Row>
                <Col>
                    <Form.Group className="mb-0">
                        <Form.Label
                            htmlFor={`filter-${props.filter.name}-field-lower`}
                        >
                            <span
                                style={
                                    {
                                        fontSize: '0.85rem',
                                        paddingLeft: '0.15rem'
                                    }
                                }
                            >{t('Providers.filters.from')}</span>
                        </Form.Label>
                        <Form.Control
                            id={`filter-${props.filter.name}-field-lower`}
                            step="any"
                            isInvalid={!props.filter.valid}
                            disabled={props.loading}
                            placeholder={"Enter Value"}
                            style={
                                {
                                    marginLeft: '0.15rem'
                                }
                            }
                            onChange={
                                (event) => {
                                    const othersValid = checkOtherFiltersValid(props.filter, props.filters);

                                    const newValue = {
                                        ...props.filter.value,
                                        lower: event.target.value
                                    }

                                    const valueInitialChanged = (props.filtersInitial.filters[props.filter.name].value.lower !== newValue.lower) || (props.filtersInitial.filters[props.filter.name].value.upper !== newValue.upper);

                                    const filterValidity = checkFieldsValidity(newValue, props.filter.validation);
                                    props.setFilters({
                                        ...props.filters,
                                        changed: true,
                                        valid: filterValidity.valid && othersValid,
                                        filters: {
                                            ...props.filters.filters,
                                            [props.filter.name]: {
                                                ...props.filter,
                                                valid: filterValidity.valid,
                                                errors: filterValidity.errors,
                                                touched: valueInitialChanged,
                                                value: newValue
                                            }
                                        }
                                    });
                                }
                            }
                            value={props.filter.value.lower}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-0">
                        <Form.Label
                            htmlFor={`filter-${props.filter.name}-field-upper`}
                        >
                            <span
                                style={
                                    {
                                        fontSize: '0.85rem',
                                        paddingLeft: '0.15rem'
                                    }
                                }
                            >{t('Providers.filters.to')}</span>
                        </Form.Label>
                        <Form.Control
                            id={`filter-${props.filter.name}-field-upper`}
                            step="any"
                            isInvalid={!props.filter.valid}
                            disabled={props.loading}
                            placeholder={"Enter Value"}
                            style={
                                {
                                    marginLeft: '0.15rem'
                                }
                            }
                            onChange={
                                (event) => {
                                    const othersValid = checkOtherFiltersValid(props.filter, props.filters);

                                    const newValue = {
                                        ...props.filter.value,
                                        upper: event.target.value
                                    }

                                    const valueInitialChanged = (props.filtersInitial.filters[props.filter.name].value.upper !== newValue.upper) || (props.filtersInitial.filters[props.filter.name].value.lower !== newValue.lower);

                                    const filterValidity = checkFieldsValidity(newValue, props.filter.validation);

                                    props.setFilters({
                                        ...props.filters,
                                        changed: true,
                                        valid: othersValid && filterValidity.valid,
                                        filters: {
                                            ...props.filters.filters,
                                            [props.filter.name]: {
                                                ...props.filter,
                                                valid: filterValidity.valid,
                                                errors: filterValidity.errors,
                                                touched: valueInitialChanged,
                                                value: newValue
                                            }
                                        }
                                    });
                                }
                            }
                            value={props.filter.value.upper}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="pt-1">
                <Col>
                    <div className={!props.filter.valid ? "is-invalid" : null} />
                    <Form.Control.Feedback
                        type="invalid"
                    >
                        {
                            props.filter.errors.map(error => {
                                return <p className="mb-0" key={createUUID()}>{error}</p>
                            })
                        }
                    </Form.Control.Feedback>
                </Col>
            </Row>
        </div>
    </Filter>
}

export default FilterRangeField;
